import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';

@Injectable()

export class OutstandingService extends ServiceGlobal {
  attendance_id: string;
  student: string;
  display_name: string;
  full_name_zh: string;
  code: string;
  school: string;
  group: string;
  group_name: string;
  activity: string;
  activity_objective: string;
  attendance_status: string;
  api_find_all: any = 'outstanding_forms';
  name_alpha: any = 'display_name';

  rule() {
    return Object.assign(super.rule(), {
      "school": {
        'search': true
      },
      "academic_year": {
        'search': true,
      },
      "filter_field": {
        "search": true,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/outstanding.service.ts